<template>
    <div class="card dashboard-card activity-timeline-graph sm-radius">
        <h2 class="heading">{{ graphHeading }}</h2>
        <div v-show="!noRecordFound && !showSpinner" class="dashboard-charts">
            <div class="chart-container">
                <div
                    :id="id"
                    class="amcharts-div activity-timeline-report"
                ></div>
            </div>
        </div>
        <base-table-spinner v-show="showSpinner"></base-table-spinner>
        <base-no-record-found v-show="noRecordFound"></base-no-record-found>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
// import AmCharts from 'amcharts3'
// import AmSerial from 'amcharts3/amcharts/serial'
// import AmPie from 'amcharts3/amcharts/pie'
import _ from 'lodash'

export default {
    // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            type: String,
            default: null,
        },
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        reset: {
            type: Number,
            default: null,
        },
        graphHeading: {
            type: String,
            required: true,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            dataProvider: [],
            resourceApi: null,
            noRecordFound: false,
            showSpinner: true,
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId', 'displaySettings']),
        cursorColor() {
            return this.displaySettings
                ? this.displaySettings.colors.primary
                : '#662D91'
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            if (value) {
                this.getStats()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.noRecordFound = false
                this.showSpinner = true
                this.getStats()
            }
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getStats()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        this.resourceApi = new resource(this.path)
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        created() {
            window.AmCharts.makeChart(this.id, {
                type: 'serial',
                pathToImages: 'https://www.amcharts.com/lib/3/images/',
                categoryField: 'date',
                dataDateFormat: 'YYYY-MM-DD',
                colors: ['#C1C1C1', '#00C535', '#C91F37'],
                color: '#1B1B1E',
                fontFamily: 'ProximanovaRegular',
                fontSize: 14,
                categoryAxis: {
                    labelFunction: function (valueText) {
                        return window.AmCharts.formatDate(
                            new Date(valueText),
                            'MMM DD'
                        )
                    },
                    gridAlpha: 1,
                    gridColor: '#F2F2F6',
                    title: '',
                },
                chartCursor: {
                    enabled: true,
                    bulletSize: 6,
                    categoryBalloonFunction: function (category) {
                        return window.AmCharts.formatDate(
                            new Date(category),
                            'MMM DD, YYYY'
                        )
                    },
                    cursorColor: this.cursorColor,
                },
                chartScrollbar: {
                    enabled: true,
                    backgroundColor: '#E8E8EF',
                    graphFillColor: '#D7D7E2',
                    graphLineColor: '#d7d7e2',
                    selectedBackgroundColor: '#F2F2F6',
                    tabIndex: 0,
                },
                trendLines: [],
                graphs: [
                    {
                        accessibleLabel: '[[category]]: [[value]]',
                        bullet: 'none',
                        fillAlphas: 0.3,
                        id: 'AmGraph-1',
                        lineThickness: 0,
                        title: 'graph 1',
                        valueField: 'onboarded',
                        type: 'column',
                        balloonFunction: function (graphDataItem) {
                            var category = graphDataItem.category
                            var value = graphDataItem.values.value
                            category = window.AmCharts.formatDate(
                                new Date(category),
                                'MMM DD, YYYY'
                            )
                            return (
                                'Onboarded on ' +
                                category +
                                ': <b>' +
                                value +
                                '</b>'
                            )
                        },
                    },
                    {
                        accessibleLabel: '[[category]]: [[value]]',

                        bullet: 'round',
                        id: 'AmGraph-2',
                        lineThickness: 2,
                        title: 'graph 2',
                        valueField: 'approved',
                        type: 'smoothedLine',
                        balloonFunction: function (graphDataItem) {
                            var category = graphDataItem.category
                            var value = graphDataItem.values.value

                            category = window.AmCharts.formatDate(
                                new Date(category),
                                'MMM DD, YYYY'
                            )
                            return (
                                'Approved on ' +
                                category +
                                ': <b>' +
                                value +
                                '</b>'
                            )
                        },
                    },
                    {
                        accessibleLabel: '[[category]]: [[value]]',
                        bullet: 'round',
                        id: 'AmGraph-3',
                        lineThickness: 2,
                        title: 'graph 3',
                        valueField: 'rejected',
                        type: 'smoothedLine',
                        balloonFunction: function (graphDataItem) {
                            var category = graphDataItem.category
                            var value = graphDataItem.values.value

                            category = window.AmCharts.formatDate(
                                new Date(category),
                                'MMM DD, YYYY'
                            )
                            return (
                                'Rejected on ' +
                                category +
                                ': <b>' +
                                value +
                                '</b>'
                            )
                        },
                    },
                ],
                guides: [],
                valueAxes: [
                    {
                        id: 'ValueAxis-1',
                        gridAlpha: 1,
                        gridColor: '#F2F2F6',
                        title: 'Total Activities',
                    },
                ],
                allLabels: [],
                balloon: {},
                titles: [],
                dataProvider: this.dataProvider,
            })
        }, // created() method ends

        async getStats() {
            this.$store.commit('setLoading', true)
            try {
                this.dataProvider = []
                this.query.dataSegmentId = this.dataSegmentId
                    ? this.dataSegmentId
                    : localStorage.getItem('activeDataSegmentId')
                let { data } = await this.resourceApi.list(this.query)
                this.showSpinner = false
                if (data && data.data) {
                    if (data.data.length) {
                        this.dataProvider = _.orderBy(data.data, 'date', 'desc')
                    } else {
                        this.noRecordFound = true
                    }
                } else {
                    this.noRecordFound = true
                }
                this.created()
            } catch (error) {
                this.$store.commit('setError', error)
            }
            this.$store.commit('setLoading', false)
        }, // getStats() methods end
    }, // End of Component > created
} // End of export default
</script>
